import template from './unauthorized.html';
import './unauthorized.styl';

const unauthorizedComponent = {
  template
};

export default unauthorizedComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/unauthorized/unauthorized.component.js
 **/